/**
 * @author xiaohuangmaoth
 * @description 考试成绩明细
 * @Date 2021/03/02
 */
import React from "react";
import { connect } from "dva";
import { framework_tool, component_tool } from "@/tool";
import { templateConfig, reduxTemplateCofig } from "./config";
import column from './column';

const { WizContainer, WizReduxTemplate } = framework_tool;
const { WizBrowserExport } = component_tool

class ExamScoreStatistics extends WizContainer {
  componentName = "ExamScoreStatistics";

  handleFile(nextProps, nextState, key) {
    const res = nextProps[key]
    const { success, data = [], msg } = res

    if (success) {
      const rows = data.map(val => ({
        ...val,
        examType: val.examType ? '课程考试' :'普通考试',
        accountState: val.accountState ? '激活' :'禁用',
        jobState: val.jobState!=null && val.jobState===1 ? '在职' :val.jobState!=null && val.jobState===0  ? '离职': '',
        pass: val.pass ? '通过' :'未通过',
      }))

      const title = '考试成绩明细'

      WizBrowserExport({
        title,
        sheetName: title,
        columns: column.filter((_, index) => index),
        rows,
        filename: title + '.xlsx',
      })
      return true

    } else {
      wizNotice.error(msg)
      return false;
    }

  }

  _render() {
    const _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig: templateConfig.call(this),
      apiDataFormat: {
        export: this.handleFile
      },
    });

    return <WizReduxTemplate {..._reduxTemplateCofig} />
  }
}

export default connect(() => ({}))(ExamScoreStatistics);
